import { styled } from "@mui/material/styles";

// Components
import { FormControl } from "@mui/material";

const styledName = "FormInput";

export const StyledFormItem = styled(FormControl, { name: styledName })({
  "&": {
    width: "100%",
    height: "fit-content",
  },
});
